
import myBottom from '@/components/myBottom/bottom.vue'
import Vue from 'vue'
import Popup from 'vux/src/components/popup/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import VueClipboard from 'vue-clipboard2'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import { PDFDocument } from 'pdf-lib'

let OSS = require('ali-oss')
const F2 = require('@antv/f2')
var echarts = require('echarts')
require('echarts-wordcloud')
Vue.use(VueClipboard)
Vue.use(ConfirmPlugin)

export default {
name: 'datareport',
components: {
Popup,
Spinner,
'myBottom': myBottom,
Icon,
Confirm
},
data () {
return {
info: {},
wordCloudList: [],
reportModule: [
{
content: '',
targetId: 1
},
{
content: '',
targetId: 2
},
{
content: '',
targetId: 3
},
{
content: '',
targetId: 4
},
{
content: '',
targetId: 5
},
{
content: '',
targetId: 6
},
{
content: '',
targetId: 7
},
{
content: '',
targetId: 8
},
{
content: '',
targetId: 9
}
],
shareLink: '',
share: this.$route.query.share || 0,
isDownLoad: false,

showImg: false,
showLoading: false,
pdfLink: '',
isConfirmshow: false
}
},
mounted () {
localStorage.setItem('school_source', 'v2') 
if (this.$route.query.type != null && this.$route.query.type === 'download') {
this.isDownLoad = true
this.showImg = true
this.showLoading = true
} else {
this.isDownLoad = false
}
this.getDetail(this.$route.query.id)
},
methods: {

downLoadPdf () {
let userAgent = navigator.userAgent.toLowerCase()
if (userAgent.indexOf('android') > -1) {
window.location.href = this.pdfLink
} else {
let _this = this
this.$copyText(this.pdfLink).then((e) => {
_this.$vux.confirm.show({
title: '提示',
content: '链接已复制，请使用浏览器打开后保存该文件',
onConfirm: () => {}
})
}, function (e) {
console.log(e)
})
}
},

dateformat (date, fmt = 'yyyy-MM-dd') {
var o = {
'M+': date.getMonth() + 1, // 月份
'd+': date.getDate(), // 日
'h+': date.getHours(), // 小时
'm+': date.getMinutes(), // 分
's+': date.getSeconds(), // 秒
'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
'S': date.getMilliseconds() // 毫秒
}
if (/(y+)/.test(fmt)) {
fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
}
for (let k in o) {
if (new RegExp('(' + k + ')').test(fmt)) {
fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
}
}
return fmt
},
uploadfile (file, callback) {





let objFile = file.file != null ? file.file : file
let paramas = new FormData()
paramas.append('type', '142')
paramas.append('platform', '13')
paramas.append('dmkj_weixin_token', this.getCookie('dmkj_weixin_token') || '')
paramas.append('fileFormat', objFile.name.slice((objFile.name.lastIndexOf('.') - 1 >>> 0) + 2))
this.$http({
method: 'post',

baseURL: '/',
url: '/commonapi/pic/get/token',
data: paramas
}).then(res => {

let info = res.data
let client = new OSS({
region: info.region,
host: info.host,
secure: true,
endpoint: info.endpoint,
accessKeyId: info.accessKeyId,
accessKeySecret: info.accessKeySecret,
stsToken: info.securityToken,
bucket: info.bucket,
timeout: '1000000'
})
let filePath = info.objectKey ? info.objectKey : info.prefix ? info.prefix : ''
client.put(filePath, file, {
type: 'text/plain',
callback: {
url: info.callbackUrl,
body: info.callbackBody,
contentType: info.callbackBodyType,
customValue: {
filename: objFile.name,
type: '142',
userid: `${this.getCookie('dmkj_teacher_id')}` || ''
}
}
}).then(result => {
callback && callback(result.data)
this.$vux.loading.hide()
}).catch(error => {
this.$vux.loading.hide()
callback && callback(error)
})
}).catch(error => {
console.log(error)
})
},
hidePopupImg () {
document.getElementById('app').style.position = 'fixed'
},
base64toBlob (base64) {
const parts = base64.split(';base64,')
const contentType = parts[0].split(':')[1]
const raw = window.atob(parts[1])
const rawLength = raw.length
const uInt8Array = new Uint8Array(rawLength)
for (let i = 0; i < rawLength; ++i) {
uInt8Array[i] = raw.charCodeAt(i)
}
return new Blob([uInt8Array], {type: contentType})
},
onCopy () {
this.$vux.toast.text('已复制')
},
onError (error) {
console.log(error)
},
initChartData (id, data) {

const chart = new F2.Chart({
id: id,
pixelRatio: window.devicePixelRatio 
})


chart.source(data || [])


chart.interval().position('name*data').color('level', ['#f1ba6b', '#484848']).adjust({
type: 'dodge',
marginRatio: 1 / 32 
})
chart.legend({
align: 'center',
itemWidth: null 
})
chart.tooltip({
onShow: function onShow (ev) {
var items = ev.items
items[0].name = items[0].name.replace('\n', '')
}
})

chart.render()
},
initChart (id, data, isPercent) {
if (data.length > 10 || data.length < 1) {
return false
}

const chart = new F2.Chart({
id: id,
pixelRatio: window.devicePixelRatio 
})

chart.source(data || [])
if (isPercent) {
chart.source(data, {
data: {
formatter: function formatter (val) {
return val + '%'
}
}
})
}
if (data.length > 6) {
chart.coord({
transposed: true
})
}
let color = []
if (data.length > 2) {
color = ['#f1ba6b']
} else {
color = ['#f1ba6b', '#484848']
}

chart.interval().position('name*data').color('name', color)
chart.legend(false)
chart.tooltip({
onShow: function onShow (ev) {
var items = ev.items
items[0].name = items[0].name.replace('\n', '')
}
})

chart.render()
},
initChartTransposed (id, data) {
if (data.length < 1) {
return false
}

const chart = new F2.Chart({
id: id,
pixelRatio: window.devicePixelRatio 
})

chart.source(data || [])
if (data.length > 6) {
chart.coord({
transposed: true
})
}

chart.interval().position('name*data').color('name', ['#f1ba6b'])
chart.legend(false)
chart.tooltip({
onShow: function onShow (ev) {
var items = ev.items
items[0].name = items[0].name.replace('\n', '')
items[0].name = items[0].name.length > 8 ? items[0].name.substring(0, 8) + '...' : items[0].name
}
})

chart.render()
},
formatChartData (data, schoolName) {
let list = []
if (data && data.length > 0) {
data.forEach(item => {
let name = ''
if (item.itemName && item.itemName.length > 4 && data.length > 4) {
item.itemName.split('').forEach((letter, index) => {
if ((index + 1) % 4 === 0) {
name += letter + '\n'
} else {
name += letter
}
})
} else {
name = item.itemName
}
if (schoolName) {
if (item.type === '11' || item.type === '12') {
list.push({
name: name || '--',
level: item.type === '11' ? schoolName : '全国',
data: parseFloat(item.itemScore || 0)
})
} else {
list.push({
name: name || '--',
level: item.type === '13' ? schoolName : '全国',
data: parseFloat(item.itemScore || 0)
})
}
} else {
if (item.type === '9') {
list.push({
name: name || '--',
data: parseFloat(item.itemScore || 0)
})
} else {
list.push({
name: name || '--',
data: parseFloat(item.itemScore || 0)
})
}
}
})
}
return list
},
getDetail (id) {
this.shareLink = window.location + '&share=1'
let params = new URLSearchParams()
params.append('id', this.$route.query.id)
var _ = this
_.loading = true
this.$http({
method: 'GET',
url: '/school/report/info',
params: params
}).then(data => {
if (data.code === 100 || data.code === '100') {
_.info = data.result
if (data.result.reportModule && data.result.reportModule.length > 0) {
_.reportModule = data.result.reportModule
_.wordCloudList = _.reportModule[0].content.split('、')
}
_.isEdit = true
let schoolName = _.info.schoolName

let chartData121 = [{ name: '全国', data: _.info.activityValue }, { name: schoolName, data: _.info.avgJoinValue }]

let chartData131 = _.formatChartData(_.info.reportItem['2'] || [])

let chartData141 = _.formatChartData(_.info.reportItem['3'] || [])

let chartData211 = _.formatChartData(_.info.reportItem['4'] || [])

let chartData212 = _.formatChartData(_.info.reportItem['5'] || [])

let chartData221 = _.formatChartData(_.info.reportItem['6'] || [])

let chartData311 = _.formatChartData(_.info.reportItem['7'] || [])

let chartData312 = _.formatChartData(_.info.reportItem['8'] || [])

let chartData313 = _.formatChartData(_.info.reportItem['9'] || [])

let chartData314 = _.formatChartData(_.info.reportItem['10'] || [])

let chartData315 = _.formatChartData(_.info.reportItem['15'] || [])

let chartData411 = [{ name: schoolName, data: parseFloat(_.info.activityCountTotal) }, { name: '全国', data: parseFloat(_.info.activityCountryNum) / 50 }]

let chartData412 = [{ name: schoolName, data: _.info.avgSchoolActivityNum }, { name: '全国', data: _.info.avgCountryActivityNum }]

let chartData421 = _.formatChartData(_.info.reportItem['11'], schoolName)
_.info.reportItem['11'] = chartData421

let chartData431 = _.formatChartData(_.info.reportItem['13'], schoolName)
_.$nextTick(() => {
_.initWordCloud(_.info.reportItem['1'])
_.initChart('chart121', chartData121)
_.initChart('chart131', chartData131, true)
_.initChart('chart141', chartData141, true)
_.initChart('chart211', chartData211, true)
_.initChart('chart212', chartData212, true)
_.initChart('chart221', chartData221, true)
_.initChartTransposed('chart311', chartData311)
_.initChartTransposed('chart312', chartData312)
_.initChartTransposed('chart313', chartData313)
_.initChartTransposed('chart314', chartData314)
_.initChartTransposed('chart315', chartData315)
_.initChart('chart411', chartData411)
_.initChart('chart412', chartData412)
_.initChartData('chart421', chartData421)
_.initChartData('chart431', chartData431)
if (_.isDownLoad) {
_.$nextTick(() => {
setTimeout(() => {
_.convertToPDF()
}, 2000)
})
}
})
} else {
_.$vux.toast.text(data.result.msg || data.msg)
}
_.loading = false
}).catch(error => {
console.log(error)
_.loading = false
})
},
initWordCloud (list) {
var chart = echarts.init(document.getElementById('wordcloud'))
let data = []
if (list && list.length > 0) {
list.forEach((item) => {
data.push({
name: item.itemName,
value: item.itemValue
})
})
}
var option = {
tooltip: {
show: false
},
series: [{
type: 'wordCloud',
gridSize: 2,
size: ['100%', '100%'],
sizeRange: [18, 35],
rotationRange: [-90, 90],
rotationStep: 45,
shape: 'square',




drawOutOfBound: false,
textStyle: {
normal: {
color: function () {
return 'rgb(' + [
Math.round(Math.random() * 160),
Math.round(Math.random() * 160),
Math.round(Math.random() * 160)
].join(',') + ')'
}
},
emphasis: {
shadowBlur: 5,
shadowColor: '#333'
}
},
data: data
}]
}
chart.setOption(option)
window.onresize = chart.resize
},
getImageProperties (imgData, cb) {

var img = new Image()
img.onload = function () {
let params = {
width: img.width,
height: img.height
}
cb && cb(params)
}
img.onerror = function () {
cb && cb(null)
}
img.src = imgData
},
async mergePDFsToBase64 (pdfDataList) {
const mergedPdf = await PDFDocument.create()
for (let pdfData of pdfDataList) {
const pdf = await PDFDocument.load(pdfData)
const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices())
copiedPages.forEach((page) => {
mergedPdf.addPage(page)
})
}
const mergedPdfBytes = await mergedPdf.save()
const mergedPdfBlob = new Blob([mergedPdfBytes], { type: 'application/pdf' })
return mergedPdfBlob
},
base64ToUint8Array (base64String) {
const padding = '='.repeat((4 - base64String.length % 4) % 4)
const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/') 
const rawData = atob(base64)
const rawLength = rawData.length
const array = new Uint8Array(new ArrayBuffer(rawLength))
for (let i = 0; i < rawLength; i += 1) {
array[i] = rawData.charCodeAt(i)
}
return array
},
async executeForLoopSequentially (i) {
let _this = this
return new Promise((resolve, reject) => {
html2canvas(document.querySelectorAll('.contenterPdf')[i], {
useCORS: true, // 允许canvas画布内 可以跨域请求外部链接图片, 允许跨域请求。
allowTaint: true, // 允许跨域
scale: 2, // 设置放大倍数
backgroundColor: '#ffffff'
}).then(async (canvas) => {
/* eslint-disable new-cap */
const pdf = new jsPDF('p', 'mm', 'a4')
var ctx = canvas.getContext('2d')
var a4w = 190
var a4h = 277
var imgHeight = Math.floor(a4h * canvas.width / a4w)
var renderedHeight = 0
while (renderedHeight < canvas.height) {
var page = document.createElement('canvas')
page.width = canvas.width
page.height = Math.min(imgHeight, canvas.height - renderedHeight)
page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0)
pdf.addImage(page.toDataURL('image/jpeg', 1.0), 'JPEG', 10, 10, a4w, Math.min(a4h, a4w * page.height / page.width))
renderedHeight += imgHeight
if (renderedHeight < canvas.height) {
pdf.addPage()
}
}
const base64Str = pdf.output('datauristring')
let dataRes = base64Str.replace(/ +/g, '')
const result = this.base64ToUint8Array(dataRes.split(',')[1])
resolve(result)






































/* eslint-disable new-cap */


























}).catch((error) => {
reject(error)
_this.$vux.toast.text('生成pdf失败，请稍后再试')
_this.showImg = false
})
})
},
async convertToPDF () {

































































let pdfDataList = []
for (let i = 0; i < document.querySelectorAll('.contenterPdf').length; i++) {
const result = await this.executeForLoopSequentially(i).catch(() => {
i = document.querySelectorAll('.contenterPdf').length
this.$vux.toast.text('生成pdf失败，请稍后再试')
this.showImg = false
})
pdfDataList.push(result)
}
let dataRes = await this.mergePDFsToBase64(pdfDataList)

let file = new File([dataRes], '数据报告.pdf', {type: 'application/pdf'})
this.uploadfile(file, (res) => {
if (res.id) {
let paramas = new FormData()
paramas.append('urlId', res.id)
this.$http({
method: 'post',
url: '/school/report/save/pdf',
data: paramas
}).then(data => {
if (+data.code === 100) {
this.pdfLink = data.result
this.showImg = true
this.showLoading = false
} else {
this.$vux.toast.text(data.msg || '')
}
})
} else {
this.$vux.toast.text('生成pdf失败，请稍后再试')
this.showImg = false
this.showLoading = false
}
})
},
saveAs (blob, filename) {
if (window.navigator.msSaveOrOpenBlob) {
navigator.msSaveBlob(blob, filename)
} else {
const link = document.createElement('a')
const body = document.querySelector('body')

link.href = window.URL.createObjectURL(blob)
link.download = filename


link.style.display = 'none'
body.appendChild(link)

link.click()
body.removeChild(link)
window.URL.revokeObjectURL(link.href)
}
}
},
filters: {
getRest (val) {
let restPercent = (100 - parseFloat(val)).toFixed(2)
return restPercent + '%'
}
}
}




// WEBPACK FOOTER //
// ./src/components/dataReport/dataReport.vue